(function () {
    'use strict';
    var controllerId = 'votoEdit';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', 'datacontext', 'studenteSession', 'votoMax', votoEditFn]);

    function votoEditFn($scope, $uibModalInstance, datacontext, studenteSession, votoMax) {
        $scope.item = {};
        $scope.item.studenteSession = studenteSession;
        $scope.item.votoMax = votoMax;

        if ($scope.item.studenteSession.voto < 2)
            $scope.item.studenteSession.voto = 2;
        
        $scope.item.votoDefault = ($scope.item.studenteSession.score / $scope.item.studenteSession.totalScore) * $scope.item.votoMax;
        if ($scope.item.votoDefault < 2)
            $scope.item.votoDefault = 2;
        
        $scope.ok = function (isValid) {
            if (isValid) {
                if ($scope.item.votoDefault == $scope.item.studenteSession.voto)
                    $scope.item.studenteSession.votoModificato = false;
                else
                    $scope.item.studenteSession.votoModificato = true;
                //console.info("modale", $scope.item.studenteSession);
                datacontext.studenteSession_update($scope.item.studenteSession).then(function (data) {
                    if (data && data.Id)
                        //data.votoModificato = $scope.item.studenteSession.votoModifica;
                        $uibModalInstance.close(data);
                });
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.ripristina = function () {
            $scope.item.studenteSession.voto = ($scope.item.studenteSession.score / $scope.item.studenteSession.totalScore) * $scope.item.votoMax;
            if ($scope.item.studenteSession.voto < 2)
                $scope.item.studenteSession.voto = 2;
            $scope.item.studenteSession.votoCommento = "";
        };
    }
})();